import { createContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import useDataApi from '../hooks/useDataApi'
import { fnGetActivitiesByBlock } from '../services/acitivities'
import { fnListBlocks, fnListBlocksPagination } from '../services/blocks'

export const BlocksContext = createContext(null)

export const BlocksContextProvider = ({ children }) => {
  const [oListBlocksPagination, fnSetABlocksPagination] = useDataApi(fnListBlocksPagination)
  const [oActivityByBlockRes, fnGetActivityByBlockReq, oActivityBlock] = useDataApi(fnGetActivitiesByBlock)
  const [nBlocksPaginmation, fnSetNBlocksPagination] = useState(1)
  const [oParams, fnSetOparamsIntern] = useState({
    cSearchTerm: "",
    bDone: false,
    page: 1,
    aFilters: [],
    bAppendToList: false,
    bPaginatedList: false,
    bUpdateList: false, // Only blocks
    bAppendActivities: false, // Only activities
  })
  const [aBlocks, fnSetABlocks] = useState([])
  const [aBlocksASortedOrder, fnSetABlocksASortedOrder] = useState([])
  const [aInitialPageActivity, fnSetInitialPageActivity] = useState([])
  const [oCurrentBlock, fnSetOCurrentBlock] = useState({})
  const [aBlocksToOrder, fnSetABlocksToOrder] = useState([])
  const [oActivitiesRequestDone, fnSetOActivitiesRequestDone] = useState({})
  const { boardId: nBoardId } = useParams()
  const location = useLocation()
  useEffect(() => {
    if (!location.pathname.includes("boards/")) return
    fnSetOparams((prev) => ({ ...prev, page: 1 }))

    fnSetABlocks([])
  }, [location])

  useEffect(() => {
    if (!oParams.bAppendToList) {
      if (!nBoardId || oListBlocksPagination.loading || oActivityByBlockRes.loading || oParams.bPaginatedList || oParams.bAppendActivities) return
    }
    fetchBlocksWithParams({ nBoardId })
  }, [oParams])


  async function fnSetOparams(oParams = {}) {
    let defaultParams = {
      bAppendToList: false,
      bPaginatedList: false,
      bUpdateList: false, // Only blocks
      bAppendActivities: false, // Only activities
    }

    // Set Set Oparams Intern to default values and then set the new values 
    fnSetOparamsIntern((prev) => ({ ...prev, ...defaultParams, ...oParams }))
  }

  // This function only updates the block
  async function fnUpdateBlockInState(index, block) {
    // Using the update function that accepts a function as an argument
    fnSetABlocks((prevBlocks) => {
      let blocks = [...prevBlocks];
      blocks[index] = block;
      return blocks;
    });

    fnSetABlocksASortedOrder((prevBlocksSorted) => {
      let blocksSorted = [...prevBlocksSorted];
      blocksSorted[index] = block;
      return blocksSorted;
    });

    fnSetInitialPageActivity((prevInitialPageActivity) => {
      let initialPageActivity = [...prevInitialPageActivity];
      initialPageActivity[index] = block;
      return initialPageActivity;
    });
  }


  async function fnFetchBlocks() {
    return await fnSetABlocksPagination({ nBoardId: nBoardId, page: oParams.page, untilThisPage: oParams.page > 1 && oParams.bPaginatedList ? oParams.page : null, search: oParams.cSearchTerm })
    // if (oParams.bAppendToList) {
    //   const aBlocksResponse = response.data.data
    //   let aUpdatedBlockList = aBlocks.filter((oBlock) => !aBlocksResponse.some((newBlock) => newBlock.opbl_nid === oBlock.opbl_nid))
    //   fnSetABlocks((prevBlocks) => [...prevBlocks, ...aUpdatedBlockList])
    // }
  }

  async function fnFetchActivities(aLoadedBlocks, additionalPage = 0) {
    if (!aLoadedBlocks?.length) return
    const aBlocksPromise = await Promise.all(aLoadedBlocks?.map(async (oBlock) => {
      await fnFetchActivitiesByBlock(oBlock.opbl_nid, additionalPage, aLoadedBlocks)
    }))
    return aBlocksPromise
  }

  async function fnFetchActivitiesByBlock(nBlockId, additionalPage = 0, aLoadedBlocks = [], bAppendActivities = false) {
    fnSetOActivitiesRequestDone(prev => ({ ...prev, [nBlockId]: false }))
    let aBlocksIntern = aBlocks.length ? aBlocks : aLoadedBlocks.length ? aLoadedBlocks : []
    if (oParams.bAppendToList) {
      aBlocksIntern = [...aBlocks, ...aLoadedBlocks]
    } else {
      if (oParams.bPaginatedList || oParams.bUpdateList) {
        aBlocksIntern = [...aLoadedBlocks]
      }
    }

    let nBlockIndex = aBlocksIntern.findIndex((oBlock) => oBlock.opbl_nid === nBlockId)

    let nBlockAlreadyExistsIndex = aBlocks?.findIndex((oBlock) => oBlock.opbl_nid === nBlockId)
    let oBlock = aBlocksIntern[nBlockIndex]
    let responseActivity = {}

    // Configurations for the request
    const oGetSortedBlocks = JSON.parse(localStorage.getItem("columnOrder"))
    const cShowDone = oParams?.bDone ? "1" : "0"
    const cPage = bAppendActivities ? `&page=${oBlock?.current_page ? oBlock.current_page + additionalPage : 1}` : `&page=1`;
    const cUntilThisPage = !bAppendActivities && oBlock?.current_page > 1 ? `&untilThisPage=${oBlock.current_page}` : "";
    const bIsSortedBlock = oGetSortedBlocks?.find((o) => o?.blockId === nBlockId);
    const cOrderSorted = bIsSortedBlock?.order?.[0] ? bIsSortedBlock?.order?.[0]?.desc ? `&orderBy=${bIsSortedBlock?.order[0].id}&order=desc ` : `&orderBy=${bIsSortedBlock?.order[0].id}&order=asc ` : "";

    // If the block is not in the list or the list is not being updated
    if (nBlockAlreadyExistsIndex == -1 || !oParams.bUpdateList) {
      responseActivity = await fnGetActivityByBlockReq(nBlockId, `show_done=${cShowDone}${cPage}${cUntilThisPage}${oParams.aFilters ? `&filters=${JSON.stringify(oParams.aFilters)}` : ""}${cOrderSorted}`)
    }

    fnSetOActivitiesRequestDone(prev => ({ ...prev, [nBlockId]: true }))

    let newOBlock = {}
    let currentBlockActivities = oBlock?.activities?.length ? oBlock?.activities : [];
    let currentBlockActivitiesPending = oBlock?.activities_pending?.length ? oBlock?.activities_pending : [];

    if (responseActivity?.data) {
      if (!oParams?.bDone) {
        newOBlock = {
          ...oBlock,
          activities_pending: bAppendActivities ? [...currentBlockActivitiesPending ?? [], ...responseActivity?.data?.data ?? []] : [...responseActivity?.data?.data ?? []],
          activities: [],
          can_load_more: responseActivity?.data?.current_page !== responseActivity?.data?.last_page,
          current_page: responseActivity?.data?.current_page,
          last_page: responseActivity?.data?.last_page,
          total: responseActivity?.data?.total,
        }
      } else {
        newOBlock = {
          ...oBlock,
          activities_pending: [],
          activities: bAppendActivities ? [...currentBlockActivities ?? [], ...responseActivity?.data?.data ?? []] : [...responseActivity?.data?.data ?? []],
          can_load_more: responseActivity?.data?.current_page !== responseActivity?.data?.last_page,
          current_page: responseActivity?.data?.current_page,
          last_page: responseActivity?.data?.last_page,
          total: responseActivity?.data?.total,
        }
      }
      if (cUntilThisPage) { // If the list is being updated with untilThisPage, then some fields cannot be updated
        newOBlock = {
          ...newOBlock,
          can_load_more: oBlock?.current_page !== oBlock?.last_page,
          current_page: oBlock?.current_page,
          last_page: oBlock?.last_page,
          total: oBlock?.total,
        }
      }
    } else {
      newOBlock = {
        ...oBlock,
        activities_pending: [...currentBlockActivitiesPending ?? []],
        activities: [...currentBlockActivities ?? []],
        can_load_more: oBlock?.current_page !== oBlock?.last_page,
        current_page: oBlock?.current_page,
        last_page: oBlock?.last_page,
        total: oBlock?.total,
      }
    }
    fnUpdateBlockInState(nBlockIndex, newOBlock)
    return newOBlock
  }
  // Get all blocks and activities from a board
  async function fetchBlocksWithParams(props) {
    const { nBoardId = nBoardId } = props
    if (oParams.page === 1 && !aBlocks?.length) {
      fnSetABlocks([])
    }
    if (oParams.page > 1 && oParams.bPaginatedList) {
      fnSetABlocks([])
    }

    let responsePagination = {}

    const bGetBlocks = !aBlocks?.length || oParams?.bAppendToList || oParams?.bUpdateList

    if (bGetBlocks) {
      responsePagination = await fnFetchBlocks();
      if (responsePagination) {
        fnSetNBlocksPagination(responsePagination?.data?.current_page + 1)
      }
    }

    const aResponseData = bGetBlocks ? responsePagination?.data?.data : aBlocks

    const aBlocksEmpty = aResponseData?.map((oBlock, index) => {
      let oCurrentBlock = aBlocks?.find((o) => o.opbl_nid === oBlock.opbl_nid)

      return {
        ...oBlock,
        activities_pending: [...oCurrentBlock?.activities_pending ?? []],
        activities: [...oCurrentBlock?.activities ?? []],
        can_load_more: oCurrentBlock?.can_load_more ?? false,
        current_page: oCurrentBlock?.current_page ?? 1,
        last_page: oCurrentBlock?.last_page ?? 1,
        total: oCurrentBlock?.total ?? 0,
      }
    }
    )
    const aBlocksFormatedFields = aBlocksEmpty?.map((oBlock) => {
      const aFields = oBlock?.fields?.map((oField) => {
        const oVisibleField = oBlock?.visible_fields?.find(
          (oVisibleField) => oVisibleField?.opvf_opfd_nid === oField?.opfd_nid,
        )
        return {
          ...oField,
          ...oVisibleField,
        }
      })

      return {
        ...oBlock,
        fields: aFields?.sort((a, b) => a?.opvf_nposition - b?.opvf_nposition),
      }
    })
    if (!aBlocksFormatedFields?.length) return responsePagination;
    if (oParams?.page === 1 || oParams.bPaginatedList) {

      fnSetInitialPageActivity(aBlocksFormatedFields)
      fnSetABlocksASortedOrder(aBlocksFormatedFields)
      fnSetABlocks(aBlocksFormatedFields)

    } else {
      fnSetInitialPageActivity((prev) => [...prev, ...aBlocksFormatedFields])
      fnSetABlocksASortedOrder((prev) => [...prev, ...aBlocksFormatedFields])
      fnSetABlocks((prev) => [...prev, ...aBlocksFormatedFields])
    }
    responsePagination = await fnFetchActivities(aBlocksFormatedFields)
    fnSetOCurrentBlock({})
    return responsePagination
  }

  // Get all blocks from a board to show in order list
  async function fnFetchBlocksToOrder(nBoardId) {
    const response = await fnSetABlocksPagination({ nBoardId: nBoardId })
    fnSetABlocksToOrder(response.data)
  }

  // Get next page of activities from a block
  async function fnGetActivitiesByBlockPages(nBlockId) {

    await fnFetchActivitiesByBlock(nBlockId, 1, [], true);

    fnSetOCurrentBlock({})
  }

  // Reset block to initial state
  function fnResetBlock(nBlockId) {
    const aBlocksCopy = [...aBlocks]
    const nBlockIndex = aBlocksCopy.findIndex((oBlock) => oBlock.opbl_nid === nBlockId)
    aBlocksCopy[nBlockIndex] = aInitialPageActivity[nBlockIndex]
    const aDataBlockUpdated = aBlocksCopy.map((oBlock, i) => {
      if (i === nBlockIndex) {
        return {
          ...oBlock,
          total: aBlocks[nBlockIndex].total,
        }
      }
      return oBlock
    }
    )
    fnSetABlocks(aDataBlockUpdated)
    fnSetOCurrentBlock({})
  }

  const value = useMemo(() => {
    return {
      aBlocks,
      aBlocksASortedOrder,
      fnSetABlocksASortedOrder,
      oParams,
      fnSetOparams,
      fnSetABlocks,
      fetchBlocksWithParams,
      fnGetActivitiesByBlockPages,
      oActivityByBlockRes,
      fnResetBlock,
      fnFetchActivitiesByBlock,
      oActivityBlock,
      fnSetOCurrentBlock,
      oCurrentBlock,
      aBlocksToOrder,
      fnSetABlocksToOrder,
      fnFetchBlocksToOrder,
      oListBlocksPagination,
      fnFetchBlocks,
      oActivitiesRequestDone
    }
  }, [aBlocks, aBlocksASortedOrder, oParams, oActivityByBlockRes, oCurrentBlock, aBlocksToOrder, oListBlocksPagination])

  return <BlocksContext.Provider value={value}>{children}</BlocksContext.Provider>
}
